export default function Footer() {
    return (
        <footer className="bg-black text-white text-center p-3">
            &copy; {new Date().getFullYear()} Anand Tech Plast Pvt Ltd. All Rights Reserved.
        </footer>
    );
}
